import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';

export function findAdditionalQuestions(
  pledge: PledgeRead,
  companyFieldType: CompanyFieldType,
): boolean {
  const additionalQuestions = pledge?.parameters?.additionalQuestions;
  if (additionalQuestions) {
    const additionalQuestion = additionalQuestions.find(
      q => q.id === companyFieldType,
    );

    if (additionalQuestion) {
      return true;
    }
  }
  return false;
}
